import { Modal, Stack } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { getQuestionnaireAnswers } from '@medplum/core'
import type {
  Practitioner,
  QuestionnaireResponse,
  Reference,
} from '@medplum/fhirtypes'
import * as questionnaires from '@seen/core/models/questionnaires/index'
import type { ExtendedTask } from '@seen/core/models/tasks/task'
import { Button } from '@seen/ui'
import type { JSX } from 'react'
import { CustomQuestionnaireForm } from '#src/components/questionnaire-form/CustomQuestionnaireForm.tsx'
import { useIsReadOnly } from '#src/hooks/useIsReadOnly.ts'
import { usePatchMutation } from '#src/hooks/usePatchMutation.ts'

export function EditTaskOwner({
  task,
}: {
  task: ExtendedTask<any>
}): JSX.Element {
  const isReadOnly = useIsReadOnly()
  const patch = usePatchMutation<ExtendedTask<any>>()
  const [opened, { toggle, close }] = useDisclosure(false)

  const handleAssignTask = async (
    owner: Reference<Practitioner>
  ): Promise<void> => {
    patch.mutate({
      instance: task,
      mutateFn: (task) => {
        task.ownerPractitioner = owner
      },
    })
  }

  const onQuestionnaireSubmit = async (
    formData: QuestionnaireResponse
  ): Promise<void> => {
    // we are using this and not clay's getTypedAnswersFromQuestionnaireResponse because clay's function does not support references
    const ownerAnswer = getQuestionnaireAnswers(formData).owner

    if (ownerAnswer?.valueReference) {
      const owner = ownerAnswer.valueReference as Reference<Practitioner>
      await handleAssignTask(owner)
      close()
    }
  }

  return (
    <div>
      <Button className="w-full" onClick={toggle} disabled={isReadOnly}>
        Assign Owner
      </Button>
      <Modal opened={opened} onClose={close}>
        <Stack>
          <CustomQuestionnaireForm
            questionnaire={questionnaires.editTaskOwnerQuestionnaire}
            onSubmit={onQuestionnaireSubmit}
          />
        </Stack>
      </Modal>
    </div>
  )
}
